// File Metadata:
// Filename: EditShipmentlog.js
// Version: 1.00
// Created: 2022-10-21 20:57:20
// Last Modified: 2025-04-01 16:55:19
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { useParams } from 'react-router-dom'
import EditShipmentlogForm from './EditShipmentlogForm'
import { useGetShipmentlogsQuery } from '../api/shipmentlogsApiSlice'
import { useGetUsersQuery } from '../api/usersApiSlice'
import useAuth from '../../hooks/useAuth'
import PulseLoader from 'react-spinners/PulseLoader'
import { Container, Box } from '@mui/material'

const EditShipmentlog = () => {
	const { id } = useParams()
	const { username, isManager, isAdmin } = useAuth()

	const { shipmentlog } = useGetShipmentlogsQuery('shipmentlogsList', {
		selectFromResult: ({ data }) => ({
			shipmentlog: data?.entities[id]
		})
	})

	const { users, isLoading, isError, error } = useGetUsersQuery
	('usersList', {
		selectFromResult: ({ data, isLoading, isError, error }) => ({
			users: data?.ids.map(id => data?.entities[id]) || [],
			isLoading,
			isError,
			error
		})
	})

	if (isLoading) return <div>Loading users...</div>
    if (isError) return <div>Error loading users: {error?.message}</div>
    if (!users.length) return <div>No users found</div>
	
	console.log('shipmentlog', shipmentlog)
	console.log('users', users)

	if (!shipmentlog || !users?.length) return <PulseLoader color='#fff' />

	if (!isManager && !isAdmin) {
		if (shipmentlog.username !== username) {
			return <p className='errmsg'>No access</p>
		}
	}
	const content = (
			<Box sx={{ width: '100%', mb: 2 }}>
			<EditShipmentlogForm shipmentlog={shipmentlog} users={users} />
			</Box>
	)

	return content
}

export default EditShipmentlog
